type Props = {
    blue?: boolean;
}

function Logo({blue=false}: Props) {

    return (
        <>
            { blue ?
                <img className="logo" src="./Umweltportal_Logo_Blau.svg" alt="Umweltportal Logo"/>
                :
                <img className="logo" src="./Umweltportal_Logo.svg" alt="Umweltportal Logo"/>
            }
        </>
    );
}

export default Logo;